import { BaseContent } from '@fourthwall/components';
import React from 'react';
import Thumbnail from '../../assets/video-thumbnail.png';
import * as S from './Video.styled';
export const Video = () => (React.createElement(S.Container, { href: "https://help.fourthwall.com/hc/en-us/articles/31440397820059-How-to-Share-Members-Only-Audio-Content-on-Spotify", target: "_blank" },
    React.createElement(S.Thumbnail, null,
        React.createElement(S.ThumbnailImage, { src: Thumbnail })),
    React.createElement("div", null,
        React.createElement("div", null,
            React.createElement(BaseContent, { size: "small" },
                React.createElement("strong", null, "How to sync Spotify with Fourthwall"))))));
